const func = $target => {
	var $form = $target.find('form'),
		$body = $('body'),
		$modal = $form.find('.modal'),
		$spinner = $modal.find('.modal-spinner');

	$form.find('input[name="action"]').val('kd/forms/submit');
	//#frm-start
	//.step
	//#frm-end

	//step 1
	var $firstStep = $form.find('#frm-start');

	$firstStep.find('.btn').on('click', function(e) {
		var $input = $firstStep.find('.form-control');
		e.preventDefault();
		//$form[0].checkValidity();
		$form.addClass('was-validated');
		//console.log($input)
		//console.log($input[0].validity)
		if ($input[0].validity.valid) {
			console.log('continue');
			window.findReplace('{' + $input.attr('name') + '}', $input.val(), $target);
			$form.removeClass('was-validated');
			//$input.removeClass('is-invalid');
			$modal.modal({
				keyboard: false
			});
			submitForm();
		} else {
			//$input.addClass('is-invalid');
		}
	});

	var $steps = $modal.find('.step').each(function(index) {
		var $step = $(this);
		$step.find('.btn[data-save="true"]').on('click', function(e) {
			e.preventDefault();
			var $input = $step.find('.form-control, .form-control-plaintext');
			$form.addClass('was-validated');
			//if ($input.attr('data-required') == '1' && $input.prop('required') == false) {
			$input.prop('required', true);
			//}

			//console.log(index + 1, $steps.length);
			if ($input[0].validity.valid) {
				window.findReplace('{' + $input.attr('name') + '}', $input.val(), $target);
				$form.removeClass('was-validated');
				//$input.removeClass('is-invalid');

				if ($input.attr('name') == 'email') {
					//console.log($input.val());
					//console.log($input.val().match('(?<=@)[^]+'));
					var domain = $input.val().match('@([^]+)')[1];
					$target.find('input, textarea, options').each(function() {
						var $this = $(this);
						//console.log($this.val(), $this.val().replace('{emailDomain}', domain));
						$this.val($this.val().replace('{emailDomain}', 'www.' + domain));
					});
				}

				/*if (index + 1 == $steps.length) {
					//last step
					//submit form
					$modal.modal('hide');
				} else {
					$step.removeClass('show');
					$steps.eq(index + 1).addClass('show');
				}*/
				proceed(index);
			}
		});
		$step.find('.btn[data-save="false"]').on('click', function(e) {
			e.preventDefault();
			var $input = $step.find('.form-control, .form-control-plaintext');
			$input.prop('required', false);
			$input.val('');
			proceed(index);
		});
	});

	function proceed(index) {
		if (index + 1 == $steps.length) {
			//last step
			//submit form
			$steps.removeClass('show');
			$spinner.addClass('show');
			submitForm();
		} else {
			submitForm();
			$steps.removeClass('show');
			$steps.eq(index + 1).addClass('show');
		}
	}

	function submitForm() {
		//console.log($form.serializeArray());
		//loop through data and set any empty values to ' '?
		//var data = $form.serializeArray();
		$form.find('.btn-primary').addClass('btn-processing');

		$.ajax({
			url: '/',
			method: 'POST',
			data: $form.serialize(),
			dataType: 'json'
		})
			.done(function(response) {
				console.log(response);
				if (response.honeypot) {
					var $honeypot = $form.find('input[name^=freeform_form_handle_]');
					$honeypot.attr('name', response.honeypot.name);
					$honeypot.attr('id', response.honeypot.name);
					$honeypot.val(response.honeypot.hash);
				}
				if (response.hash) {
					var $hash = $form.find('input[name="' + response.hash.name + '"]');
					$hash.val(response.hash.value);
				}
				if (response.csrf) {
					var $csrf = $form.find('input[name="' + response.csrf.name + '"]');
					$csrf.val(response.csrf.value);
				}
				if (response.success && response.finished) {
					$firstStep.removeClass('show');
					$target.find('#frm-end').addClass('show');
					$modal.modal('hide');
				}
				$form.find('.btn-primary').removeClass('btn-processing');
			})
			.fail(function(data) {
				console.log(data);
				$form.find('.btn-primary').removeClass('btn-processing');
			});
	}

	$modal
		.on('show.bs.modal', function(e) {
			$body.addClass('modal-backdrop-form');
		})
		.on('hide.bs.modal', function(e) {
			$spinner.removeClass('show');
			//$target.find('#frm-end').addClass('show');
		})
		.on('hidden.bs.modal', function(e) {
			$target.find('.step').removeClass('show');
			$target.find('#step00').addClass('show');
			$body.removeClass('modal-backdrop-form');

			var data = $form.serialize();
			data = data.replace('action=kd%2Fforms%2Fsubmit', 'action=kd%2Fforms%2Freset');
			//console.log(data);
			$.ajax({
				url: '/',
				method: 'POST',
				data: data,
				dataType: 'json'
			}).done(function(response) {
				//console.log(response);
				if (response.honeypot) {
					var $honeypot = $form.find('input[name^=freeform_form_handle_]');
					$honeypot.attr('name', response.honeypot.name);
					$honeypot.attr('id', response.honeypot.name);
					$honeypot.attr('value', response.honeypot.hash);
					//console.log(response.honeypot.hash);
					//console.log($honeypot[0]);
				}
				if (response.hash) {
					var $hash = $form.find('input[name="' + response.hash.name + '"]');
					$hash.val(response.hash.value);
				}
				if (response.csrf) {
					var $csrf = $form.find('input[name="' + response.csrf.name + '"]');
					$csrf.val(response.csrf.value);
				}
			});
		})
		.find('.close')
		.on('click', function(e) {
			e.preventDefault();
			$modal.modal('hide');
		});

	/*$target.find('.btn[data-step]').each(function() {
		$(this).click(function(e) {
			e.preventDefault();
			if ($(this).attr('data-step') == 'step04') {
				$modal.modal('hide');
			} else {
				$target.find('.step').removeClass('show');
				$target.find('#' + $(this).attr('data-step')).addClass('show');
			}
		});
	});*/

	/*
    var mod008 = $('[data-kd-id="008"]'),
        enquiryForm008 = $('#enquiryForm008');
    //open modal
    mod008.find('.btn').click(function(e) {
        console.log('Modal button found');
        e.preventDefault();
        enquiryForm008.modal({
            keyboard: false
        });
    });

    //modal show
    enquiryForm008.on('show.bs.modal', function() {ç
        $body.addClass('modal-backdrop-form');
    });

    //close model on click
    enquiryForm008.find('.close').click(function(e) {
        enquiryForm008.modal('hide');
    });

    //modal hide
    enquiryForm008.on('hide.bs.modal', function(e) {
        mod008.find('#frm-start').removeClass('show');
        mod008.find('#frm-end').addClass('show');
    });

    //modal hidden
    enquiryForm008.on('hidden.bs.modal', function(e) {
        //remove custom styling for nav modal backdrop
        mod008.find('.step').removeClass('show');
        mod008.find('#step00').addClass('show');
        body.removeClass('modal-backdrop-form');
    });

    //steps
    mod008.find('.btn[data-step]').each(function() {
        $(this).click(function(e) {
            e.preventDefault();
            if ($(this).attr('data-step') == 'step04') {
                enquiryForm008.modal('hide');
            } else {
                mod008.find('.step').removeClass('show');
                mod008.find('#' + $(this).attr('data-step')).addClass('show');
            }
        });
    });*/
};

export default func;
